/** @graph-connects none */
interface SelectFieldProps {
  label: string;
  value: string;
  options: readonly string[];
  onChange: (v: string) => void;
  /** 日本語value → 表示ラベルの変換マップ（未指定時はvalueをそのまま表示） */
  labelMap?: Record<string, string>;
}

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business バグ評価レビューフォームで使うラベル付きセレクトボックス。Firestore 値（日本語）を value に保ち、表示のみ labelMap で翻訳できる。
 * @graph-connects none
 */
export function SelectField({ label, value, options, onChange, labelMap }: SelectFieldProps) {
  return (
    <div>
      <label className="block text-xs font-medium text-[var(--color-text-secondary)] mb-1">
        {label}
      </label>
      <select
        // label 要素は htmlFor で結び付いていないため、支援技術には aria-label で名前を渡す
        aria-label={label}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        className="w-full rounded-md border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-2 py-1.5 text-sm"
      >
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {labelMap?.[opt] ?? opt}
          </option>
        ))}
      </select>
    </div>
  );
}
